import NotificationPreview from '../../NotificationPreview';
import React, { useEffect, useRef } from "react";
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationsListFunc,
  postNotificationFunc,
} from "../../../actions/Referrals";
import { getAgencyDetailFunc } from "../../../actions/Agency";
import CircularProgressLoading from "../../../common/CircularProgress";
import { segmentTrack } from "../../../utils/helpers/tracking_utils";

const ScheduleDeliveryStep = ({
  handleBack,
  formValues,
  closeStepperForm,
  clientMembersArr,
  onCreated,
}) => {
  const submissionPending = useRef(false);
  const dispatch = useDispatch();
  const postNotification = useSelector((state) => state.postNotification);
  const { loading, error, newNotification } = postNotification;

  const agentProfile = useSelector((state) => state.agentProfile);
  const { agentUser } = agentProfile;

  const getAgencyDetail = useSelector((state) => state.getAgencyDetail);
  const { agencyDetail } = getAgencyDetail;

  useEffect(() => {
    dispatch(getAgencyDetailFunc());
  }, [dispatch]);

  const clientIds = clientMembersArr.map((client) => client.id);

  // SUBMIT  FORM
  const submitNotificationMessageHandler = async (e) => {
    e.preventDefault();
    if (submissionPending.current || loading || !clientIds.length) return;
    submissionPending.current = true;

    const notificationMessageData = {
      client_ids: clientIds,
      title: formValues.messageTitle,
      body: formValues.messageDescription,
      cta_destination: formValues.ctaDestination || null,
      cta_label: formValues.ctaDestination ? formValues.ctaLabel?.trim() : null,
      notification_time: dayjs(new Date()).format(),
    };

    dispatch(postNotificationFunc(notificationMessageData));

    if (agentUser?.agent && agencyDetail?.agency) {
      segmentTrack({ event: "new_pn_created", agent: agentUser?.agent, agency: agencyDetail?.agency })
    }
  };

  useEffect(() => {
    if (!submissionPending.current || loading) return;
    if (error) {
      submissionPending.current = false;
      return;
    }
    if (newNotification?.ok) {
      // Consume success before dispatching: refreshing the parent list can
      // re-enter this effect before a queued setState update would commit.
      submissionPending.current = false;
      dispatch(getNotificationsListFunc());
      if (onCreated && newNotification.notification?.id) onCreated(newNotification.notification);
      else closeStepperForm();
    }
  }, [newNotification, loading, error, dispatch, onCreated, closeStepperForm]);

  return (
    <>
      {loading && <CircularProgressLoading />}
      <DialogContent sx={{ padding: "32px !important", height: "462px" }}>
        <Stack gap="16px">
          {error && <Alert severity="error">{error}</Alert>}
          <Typography variant="h6">Review your notification</Typography>
          <NotificationPreview title={formValues.messageTitle} body={formValues.messageDescription} destination={formValues.ctaDestination} buttonText={formValues.ctaLabel} />
          <Typography>This notification will be sent now to <strong>{new Set(clientIds).size} users</strong>.</Typography>
          {!clientIds.length && <Alert severity="warning">Select at least one user before sending.</Alert>}
        </Stack>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "16px 32px",
          boxShadow: "0px -2px 16px 0px rgba(0, 0, 0, 0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Button
          color="primary"
          onClick={handleBack}
          sx={{ textTransform: "uppercase", fontSize: "15px" }}
        >
          Go back
        </Button>
        <Button variant="contained" disabled={loading || !clientIds.length} onClick={submitNotificationMessageHandler}>
          {loading ? 'Sending…' : 'Send notification'}
        </Button>
      </DialogActions>
    </>
  );
};

export default ScheduleDeliveryStep;
